<script setup lang="ts">
const moments = [
  {
    image: "/images/journey/milao-duomo.jpeg",
    labelKey: "journey.moment1.label",
    titleKey: "journey.moment1.title",
    descKey: "journey.moment1.description",
  },
  {
    image: "/images/journey/milao-evento.jpeg",
    labelKey: "journey.moment2.label",
    titleKey: "journey.moment2.title",
    descKey: "journey.moment2.description",
  },
  {
    image: "/images/journey/feira-brasil.jpeg",
    labelKey: "journey.moment3.label",
    titleKey: "journey.moment3.title",
    descKey: "journey.moment3.description",
  },
];
</script>

<template>
  <UtilsSection
    class="bg-[#F1FBFE] overflow-hidden"
    container-class="max-w-screen-xl"
  >
    <div class="text-center max-w-3xl mx-auto mb-14">
      <p
        class="text-[#27C9F4] uppercase tracking-[0.3em] text-xs font-medium mb-4"
        data-aos="fade-up"
      >
        {{ $t("journey.eyebrow") }}
      </p>
      <UtilsTitle as="h2" class="text-4xl md:text-5xl" data-aos="fade-up">
        {{ $t("journey.title") }}
      </UtilsTitle>
      <UtilsSubtitle class="mt-4 text-lg text-gray-600" data-aos="fade-up">
        {{ $t("journey.subtitle") }}
      </UtilsSubtitle>
    </div>

    <div class="grid md:grid-cols-3 gap-6 lg:gap-8">
      <article
        v-for="(moment, index) in moments"
        :key="index"
        data-aos="fade-up"
        :data-aos-delay="index * 100"
        class="group relative overflow-hidden rounded-2xl bg-[#070d18] shadow-xl shadow-[#070d18]/10"
      >
        <div class="aspect-[4/5] overflow-hidden">
          <img
            :src="moment.image"
            :alt="$t(moment.titleKey)"
            class="h-full w-full object-cover transition duration-700 group-hover:scale-105"
          />
          <div
            class="absolute inset-0 bg-gradient-to-t from-[#070d18] via-[#070d18]/40 to-transparent"
          />
        </div>
        <div class="absolute bottom-0 left-0 right-0 p-6 text-white">
          <span
            class="inline-block text-[#FEE000] text-xs uppercase tracking-widest font-medium mb-2"
          >
            {{ $t(moment.labelKey) }}
          </span>
          <h3 class="font-neutron italic text-2xl mb-2">
            {{ $t(moment.titleKey) }}
          </h3>
          <p class="text-sm text-white/70 leading-relaxed">
            {{ $t(moment.descKey) }}
          </p>
        </div>
      </article>
    </div>
  </UtilsSection>
</template>
